import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {AdministrationModule} from './administration/administration.module';
import {NetworkServicesModule} from './network-services/network-services.module';
import {AdvancedModule} from './advanced/advanced.module';
import {CallFlowConfigurationsModule} from './call-flow-configurations/call-flow-configurations.module';
import {RoutingModule} from './routing/routing.module';
import {RoutingServersModule} from './routing-servers/routing-servers.module';
import {MatInputModule} from '@angular/material/input';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AdministrationModule,
    NetworkServicesModule,
    MatInputModule,
    AdvancedModule,
    CallFlowConfigurationsModule,
    RoutingModule,
    AdvancedModule,
    RoutingServersModule
  ]
})
export class SettingsModule { }
